import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  SecurityPriority,
  SecurityPriorityEnglish, // Import the other component you want to conditionally render
  Footer,
} from '../../components';
import config from '../../config';

import css from './SecurityPriorityPage.module.css';

const SecurityPriorityPageComponent = props => {
  const { scrollingDisabled, intl } = props;
  const locale = intl.locale; // Extract the current locale

  const tabs = [
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.tsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ServicesFreePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.pcTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CancellationPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.rpTabTitle' }),
      selected: false,
      linkProps: {
        name: 'RefundPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.pcmTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CausesPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.usegTabTitle' }),
      selected: false,
      linkProps: {
        name: 'SeguroUupoPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.segypTabTitle' }),
      selected: true,
      linkProps: {
        name: 'SecurityPriorityPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommunicationSafetyPage.comunicationSafetyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CommunicationSafetyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.tpcdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermProtectionPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.hipdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ProtectionDataPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SecurityPriorityPage.pcookiesTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CookiesPolicyPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'SecurityPriorityPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };

  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SecurityPriorityPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain className={css.contentHeading}>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="SecurityPriorityPage.heading" />
            </h1>
            {locale === 'en-UK' ? <SecurityPriorityEnglish /> : <SecurityPriority />}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

SecurityPriorityPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const SecurityPriorityPage = compose(
  connect(mapStateToProps),
  injectIntl
)(SecurityPriorityPageComponent);

export default SecurityPriorityPage;
